export default "__VITE_ASSET__BpW09u_V__"